import { APP_TYPES, IS_ELECTRON_WINDOW_HIDING_SUPPORTED, IS_VALID_ELECTRON_ENVIRONMENT } from '~/core/constants'
import { isUndockedEnabled } from './room-settings'
import { getUseNewMeetingsExperience } from './settings'

const getState = state => state.app

export const getAppType = state => getState(state).appType
export const getClientId = state => getState(state).clientId
export const getClientUpdateChannel = state => getState(state).clientUpdateChannel
export const getAuthenticated = state => getState(state).authenticated
export const getInitialized = state => getState(state).initialized
export const getIsElectron = state => getState(state).isElectron || Boolean(window.workd) // fix for isMeetingUndocked being called before init in work app
export const getStoreLocale = state => getState(state).locale
export const getCanLaunchUndocked = state => {
  if (getIsElectron(state) && !IS_VALID_ELECTRON_ENVIRONMENT) {
    return false
  }

  return true
}
export const getShouldLaunchUndocked = state =>
  getCanLaunchUndocked(state) && (isUndockedEnabled(state) || getUseNewMeetingsExperience(state))

export const getCanPreloadUndocked = state => getShouldLaunchUndocked(state) && IS_ELECTRON_WINDOW_HIDING_SUPPORTED

export const getUserInfo = state => getState(state).userInfo
export const getHasMeetings = state => getUserInfo(state).hasMeetings

export const getIsSummaryPage = state =>
  Object.values(APP_TYPES.SUMMARY).includes(getAppType(state))

export const isSalesforceIntegration = state =>
  APP_TYPES.SUMMARY.SALESFORCE === getAppType(state)

export const getIsMobileSummaryPage = state =>
  getAppType(state) === APP_TYPES.SUMMARY.MOBILE

export const isMeetingAssetsPage = state =>
  getAppType(state) === APP_TYPES.SUMMARY.URL
